import { FeedbackHeaderFilters } from '@/components/ui/custom/feedback/FeedbackSection';
import { ListLessonRatingParams } from '@/data/services/lessonRatingServices';
import {
  AverageStudentLessonRating,
  AverageTeacherLessonRating,
  LessonAverage,
  Rating,
  StudentLessonRating,
  TeacherLessonRating,
} from '@/models/LessonRating';

export const implementsStudentAverage = (
  average: LessonAverage,
): average is AverageStudentLessonRating => {
  return 'lessonsAverage' in average;
};

export const implementsTeacherAverage = (
  average: LessonAverage,
): average is AverageTeacherLessonRating => {
  return 'average' in average;
};

export const isStudentRating = (
  rating: Rating,
): rating is StudentLessonRating => {
  return 'lessonRating' in rating && 'teacherRating' in rating;
};

export const isTeacherRating = (
  rating: Rating,
): rating is TeacherLessonRating => {
  return 'rating' in rating && !('lessonRating' in rating);
};

export const convertTeacherRatingFilters = (
  filters?: ListLessonRatingParams,
): ListLessonRatingParams => {
  let rating: number[] = [];
  const currentRating = filters?.rating?.[0];

  if (currentRating === 1) rating = [0, 1, 2];

  if (currentRating === 2) rating = [3];

  if (currentRating === 3) rating = [4, 5];

  return {
    ...filters,
    rating,
  };
};

export const adapterFieldsToFilters = (
  originalFilters: ListLessonRatingParams = {},
  headerFilters: FeedbackHeaderFilters = {},
): ListLessonRatingParams => {
  const { rating, isRecent } = headerFilters;
  return {
    ...originalFilters,
    rating: rating ? [rating] : undefined,
    ordering: isRecent ? '-updated_at' : 'updated_at',
  };
};

export const transformedRating = (average?: number) =>
  average ? (average * 5) / 3 : 0;
